import React from 'react';
import { useAcesso } from '../hooks/useAcesso';

interface ProtecaoBotaoProps {
  children: React.ReactNode;
  tela: string;
  tipo?: 'visualizacao' | 'alteracao';
  disabled?: boolean;
}

const ProtecaoBotao: React.FC<ProtecaoBotaoProps> = ({ 
  children, 
  tela, 
  tipo = 'alteracao',
  disabled = false
}) => {
  const { temAcesso } = useAcesso();

  // Se não tem permissão para a ação, não renderiza o componente
  if (!temAcesso(tela, tipo) && tela !== "free-access") {
    return null;
  }

  return <>{children}</>;
};

export default ProtecaoBotao;